export const ANALYTICS_TOOLBAR_BUTTON_CLASS =
  "inline-flex h-8 items-center gap-2 rounded-md border border-border bg-white px-3 text-xs font-medium text-zinc-900";

export const ANALYTICS_TOOLBAR_BUTTON_NEUTRAL_CLASS =
  "inline-flex h-8 items-center gap-2 rounded-md border border-[#E5E5E5] bg-white px-3 text-xs font-medium text-[#171717]";

export const ANALYTICS_TOOLBAR_BUTTON_COMPACT_CLASS =
  "inline-flex h-6 shrink-0 items-center gap-1.5 rounded-md border border-[#E5E5E5] bg-white px-2.5 text-xs font-medium text-[#171717]";
